import { Col, Row } from "reactstrap";
import ProfitSection from "./ProfitSection/ProfitSection";
import EcommerceRevenue from "./EcommerceRevenue/EcommerceRevenue";

const Profit = () => {
  return (
    <Col xl="6">
      <Row>
        <ProfitSection />
        <EcommerceRevenue />
      </Row>
    </Col>
  );
};

export default Profit;
